import script from "./partner.vue?vue&type=script&setup=true&lang=js"
export * from "./partner.vue?vue&type=script&setup=true&lang=js"

import "./partner.vue?vue&type=style&index=0&id=4e6a80f6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6a80f6"]])

export default __exports__